import gql from 'graphql-tag';
export var NotificationType;
(function (NotificationType) {
    NotificationType["Betby"] = "BETBY";
    NotificationType["Chat"] = "CHAT";
    NotificationType["Deposit"] = "DEPOSIT";
    NotificationType["General"] = "GENERAL";
    NotificationType["Other"] = "OTHER";
    NotificationType["UiNotification"] = "UI_NOTIFICATION";
})(NotificationType || (NotificationType = {}));
export const SubscribeToNotificationsDoc = gql `
	subscription SubscribeToNotifications($playerId: UUID!, $amount: Int!) {
		subscribe(playerId: $playerId, amount: $amount) {
			notificationType
			payload
		}
	}
`;
export const SubscribeDoc = gql `
	subscription Subscribe($playerId: UUID!, $amount: Int!) {
		subscribe(playerId: $playerId, amount: $amount) {
			notificationType
			payload
		}
	}
`;
